import { Fragment, React, useEffect, useState } from "react";
import NewWindow from "react-new-window";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Icon } from "@iconify/react";
import AddIcon from "@mui/icons-material/Add";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import CallIcon from '@mui/icons-material/Call';
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import InsertEmoticonOutlinedIcon from "@mui/icons-material/InsertEmoticonOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import SaveIcon from "@mui/icons-material/Save";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";

import {
  Autocomplete,
  Chip,
  Dialog,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Popover,
  TextField,
  Tooltip,
} from "@mui/material";

import "./ChatRoom.css";
import AssignAgentModal from "./AssignAgentModal";
import EditTicketModal from "./EditTicketModal";
import HistoryDetailModal from "./HistoryDetailModal";
import MessageList from "./MessageList";
import MessageListFB from "./MessageListFB";
import MessageListIG from "./MessageListIG";
import ModalEndChat from "./ModalEndChat";
import ModalHistory from "./ModalHistory";
import SaveResultModal from "./SaveResultModal";
import ProfileInfo from "./ProfileInfo/ProfileInfo";
import CreateTicket from "../Contact/CreateTicket";
import ResultCallModal from "../Components/ResultCallModal";
import Loader from "../Components/Loader";
import WarningDialog from "../Components/WarningDialog";
import useWindowDimensions from "../Hooks/useWindowDimensions";
import QAForm from "../QA/QAForm";
import { getCampaignISPlan } from "../Store/Actions/CallAction";
import bannedWords from "../Utils/bannedWords";

import {
  getChatTags,
  getHistoryChat,
  upsertChatTags,
} from "../Store/Actions/ChatAction";

import {
  closeIGMessage,
  getIGChatInfo,
  sendIGMessage,
} from "../Store/Actions/IGAction";

import {
  addAttachment as addAttachmentLiveChat,
  closeLiveChatMessage,
  sendLiveChatMessage,
  uploadFile,
} from "../Store/Actions/LiveChatAction";

import {
  closeFBMessage,
  getFBChatInfo,
  postFacebookMessage,
} from "../Store/Actions/MetaAction";

import { getResponseTemplateList } from "../Store/Actions/TicketAction";

import {
  sendWAAudioByID,
  sendWAStickerByID,
  sendWAStickerByURL,
  sendWAVideoByID,
  uploadWAFile,
  sendWADocumentByID,
  sendWAImageByID,
  sendWAMessage,
  closeWAMessage,
  manualAssignAgent,
  getWABAChatInfo,
} from "../Store/Actions/WABAAction";

import {
  SET_AGENT_SELECTED_ASSIGNMENT,
  SET_IS_SELECTING_CONTACT,
  SET_SELECTED_CHAT,
} from "../Store/Types/AgentTypes";

import { UPDATE_CHAT, UPDATE_CHAT_SINGLE } from "../Store/Types/ChatTypes";

export default function ChatRoom({
  AgentModalButton,
  changePage,
  confirmEndChat,
  handleMessageInputChange,
  isTyping,
  selectedChat,
  setSelectedChat,
  isBack,
  setIsBack,
  setOpenModalCallPermission,
}) {
  const emojis = [
    "😀",
    "😃",
    "😄",
    "😁",
    "😆",
    "😅",
    "😂",
    "🤣",
    "😊",
    "😇",
    "🙂",
    "🙃",
    "😉",
    "😌",
    "😍",
    "😝",
    "😜",
    "🧐",
    "🤓",
    "😎",
    "😕",
    "🤑",
    "🥴",
    "😱",
  ];

  const [openModal, setOpenModal] = useState(false);
  const [optionEndChat, setOptionEndChat] = useState("");
  const [isProfileInfoOpen, setIsProfileInfoOpen] = useState(false);
  const [openModal_HistoryChat, setOpenModal_HistoryChat] = useState(false);

  const initialAttachment = {
    blob: null,
    file: "",
    mimetype: "",
    name: "",
    size: null,
  };

  const [attachment, setAttachment] = useState(initialAttachment);
  const [chatMessage, setChatMessage] = useState("");
  const [hideEmojiStickerDisplay, setHideEmojiStickerDisplay] = useState(true);
  const [toggleEmojiSticker, setToggleEmojiSticker] = useState("emoji");
  const [hideTemplateDisplay, setHideTemplateDisplay] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElMore, setAnchorElMore] = useState(null);
  const [anchorElTags, setAnchorElTags] = useState(null);
  const [anchorElChatInfo, setAnchorElChatInfo] = useState(null);
  const [anchorElCaseActionHistory, setAnchorElCaseActionHistory] = useState(null);
  const open = Boolean(anchorEl);
  const openMore = Boolean(anchorElMore);
  const openTags = Boolean(anchorElTags);
  const openChatInfo = Boolean(anchorElChatInfo);
  const openCaseActionHistory = Boolean(anchorElCaseActionHistory);
  const [openModalTicket, setOpenModalTicket] = useState(false);
  const [openModalAssignAgent, setOpenModalAssignAgent] = useState(false);
  const [openModalSave, setOpenModalSave] = useState(false);
  const [openModalCampaignDetail, setOpenModalCampaignDetail] = useState(false);
  const [pagesID, setPagesID] = useState(""); // Used for sending message in FB
  const [isSending, setIsSending] = useState(false);

  // To show loading state on confirm close chat button
  const [isEndingChat, setIsEndingChat] = useState(false);

  // Show/hide create ticket dialog
  const [isCreateTicketDialogShown, setIsCreateTicketDialogShown] =
    useState(false);

  const [agentToAssign, setAgentToAssign] = useState(null);

  const [isAssignAgentWarningShown, setIsAssignAgentWarningShown] =
    useState(false);

  const [isAssigning, setIsAssigning] = useState(false);
  const [ISPlan, setISPlan] = useState([]);
  const initialDisplayValues = { tags: [] };
  const [displayValues, setDisplayValues] = useState(initialDisplayValues);
  const [tags, setTags] = useState([]);
  const [isTagsLoading, setIsTagsLoading] = useState(true);
  const [isUpdatingTags, setIsUpdatingTags] = useState(false);
  const [chatInfo, setChatInfo] = useState(null);
  const [isChatInfoLoading, setIsChatInfoLoading] = useState(true);
  const [caseActionHistory, setCaseActionHistory] = useState([]);
  const [isCaseActionHistoryLoading, setIsCaseActionHistoryLoading] = useState(true);
  const [isNewWindowOpen, setIsNewWindowOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [isMessageValid, setIsMessageValid] = useState(true);
  const [invalidMessageCause, setInvalidMessageCause] = useState("");
  const dispatch = useDispatch();
  const { agentPermission, myInfo } = useSelector((state) => state.auth);
  const { isInCall } = useSelector((state) => state.call);
  const { width } = useWindowDimensions();

  const audioTypes = [
    "audio/aac",
    "audio/mp4",
    "audio/mpeg",
    "audio/amr",
    "audio/ogg",
  ];

  const documentTypes = [
    "text/plain",
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/msword",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const imageTypes = ["image/jpeg", "image/png"];
  const stickerTypes = ["image/webp"];
  const videoTypes = ["video/mp4", "video/3gp"];

  const stickers = [
    "https://newflat.nyc3.cdn.digitaloceanspaces.com/G03_w_sti/sticker-fan_13099335_o.webp",
    "https://newflat.nyc3.cdn.digitaloceanspaces.com/G03_w_sti/sticker-fan_13099342_o.webp",
    "https://newflat.nyc3.cdn.digitaloceanspaces.com/G03_w_sti/sticker-fan_13099330_o.webp",
    "https://newflat.nyc3.cdn.digitaloceanspaces.com/G03_w_sti/sticker-fan_13099327_o.webp",
  ];

  const onFileChange = (event) => {
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      setAttachment({
        blob: file,
        file: reader.result,
        mimetype: file.type,
        name: file.name,
        size: file.size,
      });
    };
  };

  const handleSendMessageFB = (message) => {
    setIsSending(true);
    setChatMessage("");

    // Set a timeout to setIsSending(false) after 10 seconds
    const timeout = setTimeout(() => {
      setIsSending(false);
      toast.error("Failed to send message", { autoClose: 3000 });
      console.log("Timeout: Message sending took too long.");
    }, 10000);

    postFacebookMessage({
      pagesid: pagesID,
      contactid: selectedChat.ContactID,
      message: message,
      agentid: myInfo.user.AgentID,
    })
      .then((response) => {
        if (response.status) {
          setIsSending(false);
          clearTimeout(timeout); // Clear the timeout as the response is received

          // Update selected chat
          dispatch({
            type: UPDATE_CHAT_SINGLE,

            payload: {
              chatListID: selectedChat.ChatListID,
              isNewChat: true,
            },
          });
        } else {
          console.log("error", response.error);

          toast.error("Failed to send message: " + response.error, {
            autoClose: 3000,
          });

          setIsSending(false);
          clearTimeout(timeout); // Clear the timeout as the response is received
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Failed to send message: " + err, { autoClose: 3000 });
        setIsSending(false);
        clearTimeout(timeout); // Clear the timeout as the response is received
      });
  };

  const handleSendMessageIG = (message) => {
    setIsSending(true);
    setChatMessage("");

    // Set a timeout to setIsSending(false) after 10 seconds
    const timeout = setTimeout(() => {
      setIsSending(false);
      toast.error("Failed to send message", { autoClose: 3000 });
      console.log("Timeout: Message sending took too long.");
    }, 10000);

    sendIGMessage({
      recipientigid: selectedChat.WAID,
      message: message.trim(),
    })
      .then((response) => {
        if (response.status) {
          setChatMessage("");
          setIsSending(false);
          clearTimeout(timeout); // Clear the timeout as the response is received

          // Update selected chat
          dispatch({
            type: UPDATE_CHAT_SINGLE,

            payload: {
              chatListID: selectedChat.ChatListID,
              isNewChat: true,
            },
          });
        } else {
          console.log("error", response.error);

          toast.error("Failed to send message: " + response.error, {
            autoClose: 3000,
          });

          setIsSending(false);
          clearTimeout(timeout); // Clear the timeout as the response is received
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Failed to send message: " + err, { autoClose: 3000 });
        setIsSending(false);
        clearTimeout(timeout); // Clear the timeout as the response is received
      });
  };

  const handleSendMessageLiveChat = (message) => {
    setIsSending(true);

    if (attachment.file) {
      // Upload file
      const formData = new FormData();
      formData.append("files", attachment.blob, attachment.name);

      uploadFile(formData)
        .then((responseUploadFile) => {
          if (responseUploadFile) {
            console.log("file uploaded");
            const now = moment();
            const year = now.format("YYYY");
            const month = now.format("MM");
            const date = now.format("DD");
            let filetype;
            const mime = attachment.mimetype.toLowerCase();
            if (mime.startsWith("image/")) filetype = "image";
            if (mime.startsWith("video/")) filetype = "video";
            if (mime.startsWith("audio/")) filetype = "audio";

            // documents (common office & pdf types)
            if (
              mime === "application/pdf" ||
              mime === "application/msword" ||
              mime ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || // .docx
              mime === "application/vnd.ms-excel" ||
              mime ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || // .xlsx
              mime === "application/vnd.ms-powerpoint" ||
              mime ===
                "application/vnd.openxmlformats-officedocument.presentationml.presentation" || // .pptx
              mime === "text/plain"
            ) {
              filetype = "document";
            }

            // Add attachment
            addAttachmentLiveChat({
              filetype: filetype,
              filename: `/live-chat/${year}/${month}/${date}/${attachment.name}`,
            })
              .then((responseAddAttachment) => {
                if (responseAddAttachment.status) {
                  console.log("Attachment added");

                  // Send message
                  sendLiveChatMessage({
                    // Temp hardcoded values
                    chatlistid: selectedChat.ChatListID,
                    sessionid: selectedChat.ConversationID,
                    agentid: selectedChat.AgentID,
                    livechatid: 10,
                    chatbotid: 0,
                    maindomain: "https://trial1.com/",
                    promptname: selectedChat.ContactName,
                    promptphone: selectedChat.MobileNo,
                    promptemail: selectedChat.Email,
                    promptrefno: null,
                    chatbotsessionid: null,
                    aichatbotsessionid: null,
                    type: filetype,
                    bodytext: message.trim(),
                    messagefrom: "AGENT",
                    mediaid: responseAddAttachment.data,
                  })
                    .then((responseSendMessage) => {
                      if (responseSendMessage.status) {
                        setIsSending(false);
                        setAttachment(initialAttachment);

                        // Refresh chat list and message list
                        dispatch({ type: UPDATE_CHAT });
                      } else {
                        console.log(
                          "error send message",
                          responseSendMessage.error
                        );
                        setIsSending(false);
                      }
                    })
                    .catch((err) => {
                      console.log("err", err);
                      setIsSending(false);
                    });
                } else {
                  console.log(
                    "error add attachment",
                    responseAddAttachment.error
                  );
                }
              })
              .catch((err) => {
                console.log("err", err);
              });
          } else {
            console.log("error upload file", responseUploadFile.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else if (message) {
      setChatMessage("");

      // Set a timeout to setIsSending(false) after 10 seconds
      const timeout = setTimeout(() => {
        setIsSending(false);
        toast.error("Failed to send message", { autoClose: 3000 });
        console.log("Timeout: Message sending took too long.");
      }, 10000);

      sendLiveChatMessage({
        // Temp hardcoded values
        chatlistid: selectedChat.ChatListID,
        sessionid: selectedChat.ConversationID,
        agentid: selectedChat.AgentID,
        livechatid: 10,
        chatbotid: 0,
        maindomain: "https://trial1.com/",
        promptname: selectedChat.ContactName,
        promptphone: selectedChat.MobileNo,
        promptemail: selectedChat.Email,
        promptrefno: null,
        chatbotsessionid: null,
        aichatbotsessionid: null,
        type: "text", // text | document | audio | image | video
        bodytext: message.trim(),
        messagefrom: "AGENT",
        mediaid: null,
      })
        .then((response) => {
          if (response.status) {
            setChatMessage("");
            setIsSending(false);
            clearTimeout(timeout); // Clear the timeout as the response is received

            // Refresh chat list and message list
            dispatch({ type: UPDATE_CHAT });
          } else {
            console.log("error", response.error);
            setIsSending(false);
            clearTimeout(timeout); // Clear the timeout as the response is received
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsSending(false);
          clearTimeout(timeout); // Clear the timeout as the response is received
        });
    }
  };

  const handleSendMessageWA = (message, isSticker) => {
    setIsSending(true);

    if (isSticker) {
      // Set a timeout to setIsSending(false) after 10 seconds
      const timeout = setTimeout(() => {
        setIsSending(false);
        toast.error("Failed to send message", { autoClose: 3000 });
        console.log("Timeout: Message sending took too long.");
      }, 10000);

      sendWAStickerByURL({
        recipientphoneno: selectedChat.WAID,
        sticker: { link: message },
        wabaaccountid: selectedChat.WABAAccountID,
      })
        .then((response) => {
          if (response.status) {
            setIsSending(false);
            clearTimeout(timeout); // Clear the timeout as the response is received

            // Refresh chat list and message list
            dispatch({ type: UPDATE_CHAT });
          } else {
            console.log("error", response.error);

            toast.error("Failed to send message: " + response.error, {
              autoClose: 3000,
            });

            setIsSending(false);
            clearTimeout(timeout); // Clear the timeout as the response is received
          }
        })
        .catch((err) => {
          console.log("err", err);
          toast.error("Failed to send message: " + err, { autoClose: 3000 });
          setIsSending(false);
          clearTimeout(timeout); // Clear the timeout as the response is received
        });
    } else {
      if (attachment.file) {
        uploadWAFile({
          ...attachment,
          file: attachment.file.split(",")[1],
          wabaaccountid: selectedChat.WABAAccountID,
        })
          .then((response) => {
            if (response) {
              console.log(response);

              // Audio
              if (audioTypes.includes(attachment.mimetype)) {
                sendWAAudioByID({
                  recipientphoneno: selectedChat.WAID,
                  audio: { id: response.data.id },
                  wabaaccountid: selectedChat.WABAAccountID,
                })
                  .then((response) => {
                    if (response.status) {
                      setChatMessage("");
                      setAttachment(initialAttachment);
                      setIsSending(false);

                      // Refresh chat list and message list
                      dispatch({ type: UPDATE_CHAT });
                    } else {
                      console.log("error", response.error);

                      toast.error("Failed to send message: " + response.error, {
                        autoClose: 3000,
                      });

                      setIsSending(false);
                    }
                  })
                  .catch((err) => {
                    console.log("err", err);

                    toast.error("Failed to send message: " + err, {
                      autoClose: 3000,
                    });

                    setIsSending(false);
                  });
                // Document
              } else if (documentTypes.includes(attachment.mimetype)) {
                sendWADocumentByID({
                  recipientphoneno: selectedChat.WAID,

                  document: {
                    id: response.data.id,
                    caption: chatMessage,
                    filename: attachment.name,
                  },

                  wabaaccountid: selectedChat.WABAAccountID,
                })
                  .then((response) => {
                    if (response.status) {
                      setChatMessage("");
                      setAttachment(initialAttachment);
                      setIsSending(false);

                      // Refresh chat list and message list
                      dispatch({ type: UPDATE_CHAT });
                    } else {
                      console.log("error", response.error);

                      toast.error("Failed to send message: " + response.error, {
                        autoClose: 3000,
                      });

                      setIsSending(false);
                    }
                  })
                  .catch((err) => {
                    console.log("err", err);

                    toast.error("Failed to send message: " + err, {
                      autoClose: 3000,
                    });

                    setIsSending(false);
                  });
                // Video
              } else if (videoTypes.includes(attachment.mimetype)) {
                sendWAVideoByID({
                  recipientphoneno: selectedChat.WAID,

                  video: {
                    id: response.data.id,
                    caption: chatMessage,
                  },

                  wabaaccountid: selectedChat.WABAAccountID,
                })
                  .then((response) => {
                    if (response.status) {
                      setChatMessage("");
                      setAttachment(initialAttachment);
                      setIsSending(false);

                      // Refresh chat list and message list
                      dispatch({ type: UPDATE_CHAT });
                    } else {
                      console.log("error", response.error);

                      toast.error("Failed to send message: " + response.error, {
                        autoClose: 3000,
                      });

                      setIsSending(false);
                    }
                  })
                  .catch((err) => {
                    console.log("err", err);

                    toast.error("Failed to send message: " + err, {
                      autoClose: 3000,
                    });

                    setIsSending(false);
                  });
                // Sticker
              } else if (stickerTypes.includes(attachment.mimetype)) {
                sendWAStickerByID({
                  recipientphoneno: selectedChat.WAID,
                  sticker: { id: response.data.id },
                  wabaaccountid: selectedChat.WABAAccountID,
                })
                  .then((response) => {
                    if (response.status) {
                      setAttachment(initialAttachment);
                      setIsSending(false);

                      // Refresh chat list and message list
                      dispatch({ type: UPDATE_CHAT });
                    } else {
                      console.log("error", response.error);

                      toast.error("Failed to send message: " + response.error, {
                        autoClose: 3000,
                      });

                      setIsSending(false);
                    }
                  })
                  .catch((err) => {
                    console.log("err", err);

                    toast.error("Failed to send message: " + err, {
                      autoClose: 3000,
                    });

                    setIsSending(false);
                  });
                // Image
              } else {
                sendWAImageByID({
                  recipientphoneno: selectedChat.WAID,

                  image: {
                    id: response.data.id,
                    caption: chatMessage,
                  },

                  wabaaccountid: selectedChat.WABAAccountID,
                })
                  .then((response) => {
                    if (response.status) {
                      setChatMessage("");
                      setAttachment(initialAttachment);
                      setIsSending(false);

                      // Refresh chat list and message list
                      dispatch({ type: UPDATE_CHAT });
                    } else {
                      console.log("error", response.error);

                      toast.error("Failed to send message: " + response.error, {
                        autoClose: 3000,
                      });

                      setIsSending(false);
                    }
                  })
                  .catch((err) => {
                    console.log("err", err);

                    toast.error("Failed to send message: " + err, {
                      autoClose: 3000,
                    });

                    setIsSending(false);
                  });
              }
            } else {
              console.log("error", response.error);

              toast.error("Failed to upload media: " + response.error, {
                autoClose: 3000,
              });

              setIsSending(false);
            }
          })
          .catch((err) => {
            console.log("err", err);
            toast.error("Failed to upload media: " + err, { autoClose: 3000 });
            setIsSending(false);
          });
      } else if (message) {
        setChatMessage("");

        // Set a timeout to setIsSending(false) after 10 seconds
        const timeout = setTimeout(() => {
          setIsSending(false);
          toast.error("Failed to send message", { autoClose: 3000 });
          console.log("Timeout: Message sending took too long.");
        }, 10000);

        sendWAMessage({
          recipientphoneno: selectedChat.WAID,
          message: message.trim(),
          wabaaccountid: selectedChat.WABAAccountID,
        })
          .then((response) => {
            if (response.status) {
              setChatMessage("");
              setIsSending(false);
              clearTimeout(timeout); // Clear the timeout as the response is received

              // Update selected chat after 2 seconds
              setTimeout(() => {
                dispatch({
                  type: UPDATE_CHAT_SINGLE,

                  payload: {
                    chatListID: selectedChat.ChatListID,
                    isNewChat: true,
                  },
                });
              }, 2000);
            } else {
              console.log("error", response.error);

              toast.error("Failed to send message: " + response.error, {
                autoClose: 3000,
              });

              setIsSending(false);
              clearTimeout(timeout); // Clear the timeout as the response is received
            }
          })
          .catch((err) => {
            console.log("err", err);
            toast.error("Failed to send message: " + err, { autoClose: 3000 });
            setIsSending(false);
            clearTimeout(timeout); // Clear the timeout as the response is received
          });
      }
    }

    // Update chat response status on first response
    if (chatInfo && !chatInfo.FirstResponseTime) {
      setTimeout(() => {
        fetchChatInfo();   
      }, 5000);
    }
  };

  const renderPreviewFile = () => {
    if (audioTypes.includes(attachment.mimetype)) {
      return <audio controls src={attachment.file} />;
    } else if (documentTypes.includes(attachment.mimetype)) {
      return <Icon height="200" icon="mingcute:document-2-fill" />;
    } else if (
      imageTypes.includes(attachment.mimetype) ||
      stickerTypes.includes(attachment.mimetype)
    ) {
      return (
        <img src={attachment.file} alt="" className="preview-image-container" />
      );
    } else if (videoTypes.includes(attachment.mimetype)) {
      return (
        <video controls>
          <source src={attachment.file} type={attachment.mimetype} />
          Your browser does not support the video tag.
        </video>
      );
    }
  };

  const renderSource = (source) => {
    if (source === "WABA") {
      return "Whatsapp";
    } else if (source === "FBCHAT") {
      return "Facebook";
    } else if (source === "LIVECHAT") {
      return "Live Chat";
    } else {
      return "Instagram";
    }
  };

  const TriggerClick = (id) => {
    let el = document.getElementById(id);
    if (el.onclick) {
      el.onclick();
    } else if (el.click) {
      el.click();
    }
  };

  const [responseTemplateList, setResponseTemplateList] = useState([]);

  const [isResponseTemplateListLoading, setIsResponseTemplateListLoading] =
    useState(true);

  useEffect(() => {
    getResponseTemplateList(9)
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("Response template list: ", response.data);

          setResponseTemplateList(response.data);
          setIsResponseTemplateListLoading(false);
        } else {
          console.log("error", response.error);
          setIsResponseTemplateListLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsResponseTemplateListLoading(false);
      });

    getChatTags()
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("Chat tags: ", response.data);

          setTags(response.data);

          setDisplayValues({
            ...displayValues,
            tags: selectedChat.Tags || [],
          });

          setNotes(selectedChat.Remarks);
          setIsTagsLoading(false);
        } else {
          console.log("error", response.error);
          setIsTagsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsTagsLoading(false);
      });

    fetchChatInfo();
    fetchCaseActionHistory();
  }, [selectedChat]);

  useEffect(() => {
    fetchChatInfo();
  }, [isNewWindowOpen]);
  

  function fetchChatInfo() {
    const chatInfoFunction =
      selectedChat.ChatSource === "WABA"
        ? getWABAChatInfo
        : selectedChat.ChatSource === "FBCHAT"
          ? getFBChatInfo
          : getIGChatInfo;

    chatInfoFunction(selectedChat.ChatListID)
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("Chat info: ", response.data);

          setChatInfo(response.data);
          setIsChatInfoLoading(false);
        } else {
          console.log("error", response.error);
          setIsChatInfoLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsChatInfoLoading(false);
      });
  }

  function fetchCaseActionHistory() {
    getHistoryChat(selectedChat.ChatSource, selectedChat.ChatListID)
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("Chat history: ", response.data);

          setCaseActionHistory(response.data);
          setIsCaseActionHistoryLoading(false);
        } else {
          console.log("error", response.error);
          setIsCaseActionHistoryLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsCaseActionHistoryLoading(false);
      });
  }

  const ShowModalConfirmation = (option) => {
    setOpenModal(true);
    setOptionEndChat(option);
  };

  // File size formatter
  const formatBytes = (bytes) => {
    const sizeSuffixes = ["B", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(1024));

    return (
      (!bytes && "0 Bytes") ||
      (bytes / Math.pow(1024, i)).toFixed(2) + " " + sizeSuffixes[i]
    );
  };

  const handleEndChatWABA = (params, closingMessage) => {
    setIsEndingChat(true);

    function closeMessage() {
      closeWAMessage({
        chatlistid: selectedChat.ChatListID,
        session: selectedChat.Session,
        type: params?.type,
        assignmentid: selectedChat.AssignmentID,
        iscode: params?.ISCode,
        iscodereason: params?.ISCodeReason,
        wabaid: selectedChat.WABAAccountID,
        remarks: params?.remarks,
      })
        .then((responseClose) => {
          if (responseClose.status) {
            console.log("Response end chat: ", responseClose.data);
            setSelectedChat(null);

            // Refresh chat list and message list
            dispatch({ type: UPDATE_CHAT });

            setOpenModal(false);
            setIsEndingChat(false);
            toast.success("Chat ended", { autoClose: 3000 });
          } else {
            console.log("error", responseClose.error);
            setIsEndingChat(false);

            toast.error("Error closing chat. " + responseClose.error, {
              autoClose: 3000,
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsEndingChat(false);
          toast.error("Error closing chat. " + err, { autoClose: 3000 });
        });
    }

    if (closingMessage) {
      sendWAMessage({
        recipientphoneno: selectedChat.WAID,
        message: closingMessage,
        wabaaccountid: selectedChat.WABAAccountID,
      })
        .then((responseSend) => {
          if (responseSend.status) {
            closeMessage();
          } else {
            console.log("error", responseSend.error);
            setIsEndingChat(false);

            toast.error(
              "Error sending closing message. " + responseSend.error,
              { autoClose: 3000 }
            );
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsEndingChat(false);

          toast.error("Error sending closing message. " + err, {
            autoClose: 3000,
          });
        });
    } else {
      closeMessage();
    }
  };

  const handleEndChatFB = (closingMessage) => {
    setIsEndingChat(true);

    function closeMessage() {
      closeFBMessage({
        conversationid: selectedChat.ChatListID,
        caseid: selectedChat.CaseID,
      })
        .then((response) => {
          if (response.status) {
            console.log("Response end chat FB: ", response.data);
            setSelectedChat(null);

            // Refresh chat list and message list
            dispatch({ type: UPDATE_CHAT });

            setOpenModal(false);
            setIsEndingChat(false);
            toast.success("Chat ended", { autoClose: 3000 });
          } else {
            console.log("error", response.error);
            setIsEndingChat(false);

            toast.error("Error closing chat. " + response.error, {
              autoClose: 3000,
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsEndingChat(false);
          toast.error("Error closing chat. " + err, { autoClose: 3000 });
        });
    }

    if (closingMessage) {
      postFacebookMessage({
        pagesid: pagesID,
        contactid: selectedChat.ContactID,
        message: closingMessage,
        agentid: myInfo.user.AgentID,
      })
        .then((response) => {
          if (response.status) {
            closeMessage();
          } else {
            console.log("error", response.error);
            setIsEndingChat(false);

            toast.error("Error sending closing message. " + response.error, {
              autoClose: 3000,
            });
          }
        })
        .catch((err) => {
          console.log("error", err);
          setIsEndingChat(false);

          toast.error("Error sending closing message. " + err, {
            autoClose: 3000,
          });
        });
    } else {
      closeMessage();
    }
  };

  const handleEndChatIG = (isticket, closingMessage) => {
    setIsEndingChat(true);

    function closeMessage() {
      closeIGMessage({
        chatlistid: +selectedChat.ChatListID,
        type: isticket === true ? 1 : 0,
        igcontactid: 11, // hardcode temp
      })
        .then((response) => {
          if (response.status) {
            console.log("Response end chat: ", response.data);
            setSelectedChat(null);

            // Refresh chat list and message list
            dispatch({ type: UPDATE_CHAT });

            setOpenModal(false);
            setIsEndingChat(false);
            toast.success("Chat ended", { autoClose: 3000 });
          } else {
            console.log("error", response.error);
            setIsEndingChat(false);

            toast.error("Error closing chat. " + response.error, {
              autoClose: 3000,
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsEndingChat(false);
          toast.error("Error closing chat. " + err, { autoClose: 3000 });
        });
    }

    if (closingMessage) {
      sendIGMessage({
        recipientigid: selectedChat.WAID,
        message: closingMessage,
      })
        .then((response) => {
          if (response.status) {
            closeMessage();
          } else {
            console.log("error", response.error);
            setIsEndingChat(false);

            toast.error("Error sending closing message. " + response.error, {
              autoClose: 3000,
            });
          }
        })
        .catch((err) => {
          console.log("error", err);
          setIsEndingChat(false);

          toast.error("Error sending closing message. " + err, {
            autoClose: 3000,
          });
        });
    } else {
      closeMessage();
    }
  };

  const handleEndChatLiveChat = () => {
    setIsEndingChat(true);

    closeLiveChatMessage({
      chatlistid: selectedChat.ChatListID,
      sessionid: selectedChat.ConversationID,
    })
      .then((response) => {
        if (response.status) {
          console.log("Response end chat: ", response.data);
          setSelectedChat(null);

          // Refresh chat list and message list
          dispatch({ type: UPDATE_CHAT });

          setOpenModal(false);
          setIsEndingChat(false);
        } else {
          console.log("error", response.error);
          setIsEndingChat(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsEndingChat(false);
      });
  };

  const handleEndChat = (isticket, closingMessage) => {
    if (selectedChat.ChatSource === "WABA") {
      handleEndChatWABA(undefined, closingMessage);
    } else if (selectedChat.ChatSource === "FBCHAT") {
      handleEndChatFB(closingMessage);
    } else if (selectedChat.ChatSource === "IG" && isticket === true) {
      handleEndChatIG(isticket, closingMessage);
    } else if (selectedChat.ChatSource === "LIVECHAT") {
      handleEndChatLiveChat();
    } else handleEndChatIG(undefined, closingMessage);
  };

  const EndSession = () => {
    return (
      <div>
        <Tooltip title="End Session" arrow>
          <IconButton
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
            }}
            aria-controls={open ? "Filter_menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <ErrorOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          id="endChatButton"
          open={open}
          onClose={() => setAnchorEl(null)}
          onClick={() => setAnchorEl(null)}
          transformOrigin={{ horizontal: "center", vertical: "top" }}
          anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        >
          {renderEndSessionMenuItems()}

          <MenuItem
            sx={{
              fontSize: "14px",
              padding: "6px 14px",
            }}
            onClick={() => ShowModalConfirmation("endChat")}
          >
            <ListItemIcon>
              <AnnouncementIcon />
            </ListItemIcon>
            End Chat
          </MenuItem>
        </Menu>
      </div>
    );
  };

  function assignAgent() {
    setIsAssigning(true);

    manualAssignAgent({
      agentid: agentToAssign.AgentID,
      assignby: myInfo.user.AgentID,
      chatlistid: Number(selectedChat.ChatListID),
    })
      .then((response) => {
        if (response.status) {
          toast.success("Chat assigned successfully", { autoClose: 3000 });
          setIsAssigning(false);
          setIsAssignAgentWarningShown(false);
          setOpenModalAssignAgent(false);
          dispatch({ type: UPDATE_CHAT });
        } else {
          console.log("error", response.error);
          toast.error("Error assigning chat", { autoClose: 3000 });
          setIsAssigning(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Error assigning chat", { autoClose: 3000 });
        setIsAssigning(false);
      });
  }

  function selectContact() {
    changePage("contact");

    dispatch({
      type: SET_SELECTED_CHAT,
      payload: selectedChat,
    });

    dispatch({
      type: SET_IS_SELECTING_CONTACT,
      payload: true,
    });
  }

  const ButtonAccess = () => {
    const QAPermission = agentPermission.find(
      (permission) => permission.PermissionCode === "User.AccessQAFormChat"
    );

    return (
      <div className="header-right">
        {selectedChat.ChatSource === "WABA" && (
          <Tooltip title="Call Customer" arrow>
            <IconButton onClick={() => setOpenModalCallPermission(true)}>
              <CallIcon />
            </IconButton>
          </Tooltip>
        )}

        {selectedChat.ChatSource === "WABA" &&
          myInfo.user.Level > 0 &&
          selectedChat.IsActive && (
            <Tooltip title="Assign Agent" arrow>
              <IconButton onClick={() => setOpenModalAssignAgent(true)}>
                <PersonAddAlt1Icon />
              </IconButton>
            </Tooltip>
          )}

        {/* {(selectedChat.ChatSource === "LIVECHAT" ||
            selectedChat.ChatSource === "WA" ||
            selectedChat.ChatSource === "WABA") &&
            (selectedChat.OutboundContactID ? ( */}

        {selectedChat.ContactID ? (
          <Tooltip title="Contact information" arrow>
            <IconButton
              onClick={() => setIsProfileInfoOpen(true)}
              className="profileButton"
              disabled={isProfileInfoOpen}
            >
              <Icon icon="mdi:card-account-details-outline" color="#727272" />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Select contact" arrow>
            <IconButton className="profileButton" onClick={selectContact}>
              <Icon icon="mdi:card-account-details-outline" color="#727272" />
            </IconButton>
          </Tooltip>
        )}

        {(selectedChat.AssignmentID || selectedChat.CampaignContactID) && (
          <Tooltip title="Assignment details" arrow>
            <IconButton
              onClick={() => {
                dispatch({
                  type: SET_AGENT_SELECTED_ASSIGNMENT,

                  payload:
                    selectedChat.AssignmentID ?? selectedChat.CampaignContactID,
                });

                changePage("campaign");
              }}
            >
              <Icon icon="ic:outline-assignment" color="#727272" />
            </IconButton>
          </Tooltip>
        )}

        {/* Hide in live chat */}
        {selectedChat.ChatSource !== "LIVECHAT" && (
          <Tooltip title="Chat History" arrow>
            <IconButton
              onClick={() => setOpenModal_HistoryChat(true)}
              disabled={openModal_HistoryChat}
            >
              <Icon icon="mdi:message-text-clock-outline" color="#727272" />
            </IconButton>
          </Tooltip>
        )}

        {(selectedChat.ChatSource === "WABA" ||
          selectedChat.ChatSource === "IG" ||
          selectedChat.ChatSource === "FBCHAT") && (
          <>
            <Tooltip title="Case Action History" arrow>
              <IconButton
                onClick={(e) => setAnchorElCaseActionHistory(e.currentTarget)}
              >
                <Icon icon="ix:history-list" color="#727272" />
              </IconButton>
            </Tooltip>

            <Popover
              anchorEl={anchorElCaseActionHistory}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              open={openCaseActionHistory}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              onClose={() => setAnchorElCaseActionHistory(null)}
            >
              <div className="case-action-history-popover">
                {isCaseActionHistoryLoading ? (
                  <Loader />
                ) : (
                  <div className="container-timeline">
                    <div className="timeline">
                      {caseActionHistory.length ? (
                        caseActionHistory.map((action, index, arr) => {
                          return (
                            <Fragment key={index}>
                              {(!moment
                                .utc(action.event_time)
                                .isSame(
                                  moment.utc(arr[index - 1]?.event_time),
                                  "date"
                                ) ||
                                index === 0) && (
                                <div className="date">
                                  {moment
                                    .utc(action.event_time)
                                    .format("DD MMM YYYY")}
                                </div>
                              )}

                              <div
                                className="item-container"
                                key={action.history_id}
                              >
                                <div
                                  className="item-icon"
                                  style={{ backgroundColor: "darkblue" }}
                                >
                                  <Icon
                                    height="24"
                                    icon="material-symbols:circle-outline"
                                    width="24"
                                  />
                                </div>

                                <div className="item">
                                  <header>
                                    <div className="time">
                                      <Icon
                                        icon="mingcute:time-line"
                                        width="18"
                                        height="18"
                                      />

                                      <p>
                                        {moment
                                          .utc(action.event_time)
                                          .format("DD/MM/YYYY HH:mm")}
                                      </p>
                                    </div>
                                  </header>

                                  <p className="message">{action.wording}</p>
                                </div>
                              </div>
                            </Fragment>
                          );
                        })
                      ) : (
                        <p className="no-interaction">
                          No case action history found
                        </p>
                      )}

                      <div className="item-container">
                        <div
                          className="item-icon"
                          style={{ backgroundColor: "#727272" }}
                        >
                          <Icon
                            height="24"
                            icon="icon-park-outline:stopwatch-start"
                            width="24"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Popover>

            <Tooltip title="Time Info" arrow>
              <IconButton onClick={(e) => setAnchorElChatInfo(e.currentTarget)}>
                <Icon icon="streamline-sharp:time-lapse" color="#727272" />
              </IconButton>
            </Tooltip>

            <Popover
              anchorEl={anchorElChatInfo}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              open={openChatInfo}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => setAnchorElChatInfo(null)}
            >
              <div className="time-info-popover">
                {isChatInfoLoading ? (
                  <Loader />
                ) : !chatInfo?.FirstResponseTime && !chatInfo?.ResolvedTime ? (
                  <p className="waiting-response">
                    Waiting response from agent
                  </p>
                ) : (
                  <>
                    {chatInfo?.FirstResponseTime && (
                      <div>
                        <p>First response time:</p>

                        <p>
                          {moment(chatInfo.FirstResponseTime).format(
                            "D MMMM YYYY, HH:mm:ss"
                          )}
                        </p>
                      </div>
                    )}

                    {chatInfo?.FirstResponseWaitDuration && (
                      <div>
                        <p>First response wait duration:</p>
                        <p>{chatInfo.FirstResponseWaitDuration}</p>
                      </div>
                    )}

                    {chatInfo?.ResolvedTime && (
                      <div>
                        <p>Resolved time:</p>

                        <p>
                          {moment(chatInfo.ResolvedTime).format(
                            "D MMMM YYYY, HH:mm:ss"
                          )}
                        </p>
                      </div>
                    )}

                    {chatInfo?.CaseDuration && (
                      <div>
                        <p>Case duration:</p>
                        <p>{chatInfo.CaseDuration}</p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Popover>
          </>
        )}

        <Tooltip title="Tags & Notes" arrow>
          <IconButton onClick={(e) => setAnchorElTags(e.currentTarget)}>
            <Icon icon="mdi:tag-edit" color="#727272" />
          </IconButton>
        </Tooltip>

        <Popover
          anchorEl={anchorElTags}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={openTags}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() => setAnchorElTags(null)}
        >
          <div className="tags-popover">
            <Autocomplete
              disableClearable
              disabled={isUpdatingTags}
              filterSelectedOptions
              fullWidth
              loading={isTagsLoading}
              multiple
              options={tags}
              value={displayValues.tags}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              onChange={(event, value) => {
                setDisplayValues({
                  ...displayValues,
                  tags: value,
                });
              }}
              renderInput={(params) => <TextField {...params} label="Tags" />}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <div key={option.id} {...getTagProps({ index })}>
                    <Chip
                      label={option.name}
                      sx={{
                        backgroundColor: option.color,
                        color: "#fff",

                        "& .MuiChip-deleteIcon": {
                          color: "#fff",
                          "&:hover": {
                            color: "#e0e0e0", // slightly darker than white
                          },
                        },
                      }}
                      onDelete={getTagProps({ index }).onDelete}
                    />
                  </div>
                ))
              }
            />

            <TextField
              disabled={isUpdatingTags}
              fullWidth
              label="Notes"
              multiline
              minRows={5}
              placeholder="Add notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />

            <section className="buttons">
              <button
                className="cancel"
                type="button"
                onClick={() => setAnchorElTags(null)}
              >
                Cancel
              </button>

              <button
                className="confirm"
                disabled={isUpdatingTags}
                onClick={() => {
                  setIsUpdatingTags(true);

                  upsertChatTags({
                    chatlistid: selectedChat.ChatListID,
                    remarks: notes,
                    source: selectedChat.ChatSource,
                    tagid: displayValues.tags.map((tag) => tag.id),
                  })
                    .then((response) => {
                      if (response.status) {
                        setIsUpdatingTags(false);

                        // Update selected chat
                        dispatch({
                          type: UPDATE_CHAT_SINGLE,

                          payload: {
                            chatListID: selectedChat.ChatListID,
                          },
                        });

                        toast.success("Tags & notes updated successfully", {
                          autoClose: 3000,
                        });
                      } else {
                        console.log(
                          "Error updating tags & notes: ",
                          response.error,
                          "payload: ",

                          {
                            chatlistid: selectedChat.ChatListID,
                            remarks: notes,
                            source: selectedChat.ChatSource,
                            tagid: displayValues.tags.map((tag) => tag.id),
                          }
                        );

                        setIsUpdatingTags(false);

                        toast.error(
                          "Error updating tags & notes: " + response.error,
                          { autoClose: 3000 }
                        );
                      }
                    })
                    .catch((err) => {
                      console.log(
                        "Error updating tags & notes: ",
                        err,
                        "payload: ",

                        {
                          chatlistid: selectedChat.ChatListID,
                          remarks: notes,
                          source: selectedChat.ChatSource,
                          tagid: displayValues.tags.map((tag) => tag.id),
                        }
                      );

                      setIsUpdatingTags(false);

                      toast.error("Error updating tags & notes: " + err, {
                        autoClose: 3000,
                      });
                    });
                }}
              >
                {isUpdatingTags ? "Updating..." : "Update"}
              </button>
            </section>
          </div>
        </Popover>

        {QAPermission &&
          QAPermission.PermissionAccess === "A" &&
          !selectedChat.IsActive && (
            <Tooltip title="Open QA Form" arrow>
              <IconButton onClick={() => setIsNewWindowOpen(true)}>
                <Icon icon="iconamoon:file-check-light" color="#727272" />
              </IconButton>
            </Tooltip>
          )}

        {selectedChat.IsActive && EndSession()}

        {openModal ? (
          <ModalEndChat
            // assignmentid={detailchat?.AssignmentID}
            // caseid={detailchat?.CaseID}
            // confirmEndChat={confirmEndChat}
            handleEndChat={handleEndChat}
            isEndingChat={isEndingChat}
            optionEndChat={optionEndChat}
            igTicketEndchat={selectedChat.ChatSource === "IG"}
            setIsCreateTicketDialogShown={setIsCreateTicketDialogShown}
            onClose={() => setOpenModal(false)}
            chatSource={selectedChat.ChatSource}
          />
        ) : (
          ""
        )}
      </div>
    );
  };

  // Profanity filter
  const escapeRegExp = (word) => word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const bannedWordRegex = new RegExp(
    `(?:^|[^\\p{L}\\p{N}_])(?:${bannedWords.map(escapeRegExp).join("|")})(?=$|[^\\p{L}\\p{N}_])`,
    "iu"
  );

  const hasBannedWord = (text) => bannedWordRegex.test(text);

  function renderEndSessionMenuItems() {
    const menuItems = [];

    if (
      ((selectedChat.ChatSource === "WABA" &&
        selectedChat.InitiatedBy === "AGENT") ||
        (selectedChat.ChatSource === "WA" && selectedChat.FromMe)) &&
      selectedChat.CampaignID
    ) {
      menuItems.push(
        <MenuItem
          sx={{
            fontSize: "14px",
            padding: "6px 14px",
          }}
          onClick={() =>
            getCampaignISPlan(selectedChat.CampaignID)
              .then((response) => {
                if (response.status) {
                  setISPlan(response.data);
                } else {
                  console.log("error", response.error);
                }

                setOpenModalSave(true);
              })
              .catch((err) => {
                toast.error("Error loading IS Plan", { autoClose: 3000 });
                console.log("err", err);
              })
          }
        >
          <ListItemIcon>
            <SaveIcon />
          </ListItemIcon>
          Add Interaction
        </MenuItem>
      );
    }

    if (
      (selectedChat.ChatSource === "WABA" &&
        selectedChat.InitiatedBy === "CUSTOMER") ||
      (selectedChat.ChatSource === "WA" && !selectedChat.FromMe) ||
      selectedChat.ChatSource === "LIVECHAT" ||
      selectedChat.ChatSource === "IG" ||
      selectedChat.ChatSource === "FBCHAT"
    ) {
      menuItems.push(
        <MenuItem
          sx={{
            fontSize: "14px",
            padding: "6px 14px",
          }}
          onClick={() => ShowModalConfirmation("addTicket")}
        >
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          Add Ticket
        </MenuItem>
      );
    }

    return menuItems;
  }

  return (
    <div
      className={isBack ? "chat-room-hidden" : "chat-room"}
      id="chatroom_listmessage"
    >
      {attachment.file && (
        <div className="preview-file-overlay">
          <CloseOutlinedIcon
            className="close-preview-button"
            sx={{ fontSize: 36 }}
            onClick={() => setAttachment(initialAttachment)}
          />

          {renderPreviewFile()}

          <p className="preview-file-details">
            {attachment.name} - {formatBytes(attachment.size)}
          </p>
        </div>
      )}

      <div className="chat-room-header">
        <div
          className={`header-container ${isInCall && "in-call"} ${
            isInCall && isProfileInfoOpen === false && "full"
          }`}
        >
          <div className="header-info">
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="back-button">
                <Tooltip title="back" arrow>
                  <IconButton onClick={() => setIsBack(true)}>
                    <ArrowBackIosNewIcon />
                  </IconButton>
                </Tooltip>
              </div>

              <span className="header-contact-info">
                <h3>
                  {selectedChat.ContactName
                    ? selectedChat.ContactName
                    : selectedChat.ProfileName
                      ? selectedChat.ProfileName
                      : "Unknown Contact"}
                </h3>

                <h4>{`${
                  selectedChat.MobileNo ? selectedChat.MobileNo + " - " : ""
                } ${renderSource(selectedChat.ChatSource)}`}</h4>
              </span>
            </div>

            {ButtonAccess()}
          </div>
        </div>

        <div
          className={`header-info-space ${
            isInCall && isProfileInfoOpen === false && "hidden"
          }`}
        />
      </div>

      <div className={`chat-room-body ${isProfileInfoOpen && "compact"}`}>
        <div
          className={`chat-room-body-content ${
            selectedChat.IsActive ? "" : "inactive"
          } ${isInCall ? "in-call" : ""}`}
        >
          {selectedChat.ChatSource === "WABA" ||
          selectedChat.ChatSource === "LIVECHAT" ? (
            <MessageList
              chatListID={selectedChat.ChatListID}
              isLiveChat={selectedChat.ChatSource === "LIVECHAT"}
              isTyping={isTyping}
            />
          ) : selectedChat.ChatSource === "FBCHAT" ? (
            <MessageListFB
              chatListID={selectedChat.ChatListID}
              sessionNo={selectedChat.Session}
              setPagesID={setPagesID}
            />
          ) : (
            <MessageListIG chatListID={selectedChat.ChatListID} />
          )}
        </div>
      </div>

      {selectedChat.IsActive && (
        <div className={`chat-box ${isProfileInfoOpen && "compact"}`}>
          {selectedChat.IsSessionActive === false ? (
            <p className="session-ended">
              This live chat session has been ended by the customer
              <br />
              <span className="time">
                {moment(selectedChat.InactiveTime).format("DD/MM/YY, HH:mm")}
              </span>
            </p>
          ) : (
            <>
              <div
                className="emoji-sticker-container"
                style={{ display: hideEmojiStickerDisplay ? "none" : "block" }}
              >
                <nav className="selector">
                  <p
                    className={toggleEmojiSticker === "emoji" ? "selected" : ""}
                    onClick={() => setToggleEmojiSticker("emoji")}
                  >
                    Emoji
                  </p>

                  <p
                    className={
                      toggleEmojiSticker === "sticker" ? "selected" : ""
                    }
                    onClick={() => setToggleEmojiSticker("sticker")}
                  >
                    Sticker
                  </p>
                </nav>

                {toggleEmojiSticker === "emoji" ? (
                  <div className="emoji-container">
                    {emojis.map((e) => (
                      <button
                        className="emoji"
                        key={e}
                        onClick={() => setChatMessage(chatMessage + e)}
                      >
                        {e}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="sticker-container">
                    {stickers.map((sticker) => (
                      <img
                        alt=""
                        className="sticker"
                        src={sticker}
                        onClick={() => {
                          handleSendMessageWA(sticker, true);
                          setHideEmojiStickerDisplay(true);
                          setToggleEmojiSticker("emoji");
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>

              <div
                className="template-container"
                style={{ display: hideTemplateDisplay ? "none" : "block" }}
              >
                <p>Response Template</p>

                <div className="response-template-list">
                  {isResponseTemplateListLoading ? (
                    <Loader />
                  ) : (
                    responseTemplateList.map((responseTemplate) => (
                      <button
                        key={responseTemplate.TemplateID}
                        onClick={() => {
                          // Add line break after closing <p> tag
                          let strippedHTML =
                            responseTemplate.Description.replace(
                              /<\/p>/g,
                              "</p>\n"
                            );

                          // Remove all HTML tags
                          setChatMessage(strippedHTML.replace(/<[^>]+>/g, ""));
                          setHideTemplateDisplay(true);
                        }}
                      >
                        {responseTemplate.Name}
                      </button>
                    ))
                  )}
                </div>
              </div>

              <div className="chat-box-content">
                {
                  // Hide on IG
                  selectedChat.ChatSource !== "IG" && (
                    <div className="chat-box-buttons">
                      <input
                        accept=".aac,.mp4,.mp3,.amr,.ogg,.txt,.pdf,.ppt,.doc,.xls,.docx,.pptx,.xlsx,.jpeg,.jpg,.webp,.png,.3gp,audio/aac,audio/mp4,audio/mpeg,audio/amr,audio/ogg,text/plain,application/pdf,application/vnd.ms-powerpoint,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png,image/webp,video/mp4,video/3gp"
                        id="inputFileChat"
                        type="file"
                        hidden
                        onClick={(e) => (e.target.value = null)}
                        onChange={onFileChange}
                      />

                      <Tooltip arrow placement="top" title="Attach File">
                        <IconButton
                          className="add-file-button"
                          onClick={() => TriggerClick("inputFileChat")}
                        >
                          <AttachFileOutlinedIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip arrow placement="top" title="Add Emoji/Sticker">
                        <IconButton
                          className="add_emote"
                          disabled={audioTypes.includes(attachment.mimetype)}
                          onClick={() => {
                            setHideEmojiStickerDisplay(
                              !hideEmojiStickerDisplay
                            );

                            setHideTemplateDisplay(true);
                          }}
                        >
                          {hideEmojiStickerDisplay ? (
                            <InsertEmoticonOutlinedIcon />
                          ) : (
                            <Icon icon="ph:x-bold" color="#727272" />
                          )}
                        </IconButton>
                      </Tooltip>

                      <Tooltip
                        arrow
                        placement="top"
                        title="Insert Response Template"
                      >
                        <IconButton
                          className="add_template"
                          disabled={audioTypes.includes(attachment.mimetype)}
                          onClick={() => {
                            setHideEmojiStickerDisplay(true);
                            setHideTemplateDisplay(!hideTemplateDisplay);
                          }}
                        >
                          <Icon
                            icon={
                              hideTemplateDisplay
                                ? "heroicons-outline:template"
                                : "ph:x-bold"
                            }
                            color="#727272"
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  )
                }

                <form
                  className={`message-input-container ${!isMessageValid ? "invalid-message" : ""}`}
                >
                  <TextField
                    className="message-input"
                    disabled={audioTypes.includes(attachment.mimetype)}
                    InputLabelProps={{ shrink: false }}
                    maxRows={3}
                    multiline
                    placeholder="Type a message..."
                    value={chatMessage}
                    onChange={(e) => {
                      setIsMessageValid(true);
                      setInvalidMessageCause("");
                      setChatMessage(e.target.value);

                      selectedChat.ChatSource === "LIVECHAT" &&
                        handleMessageInputChange(selectedChat.ConversationID);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        if (e.shiftKey) {
                          // Shift+Enter → allow newline
                          return;
                        }

                        e.preventDefault();

                        if (hasBannedWord(chatMessage)) {
                          setIsMessageValid(false);

                          setInvalidMessageCause(
                            "Your message contained banned words."
                          );

                          return;
                        }

                        if (
                          selectedChat.MinCharPerChat &&
                          chatMessage.length < selectedChat.MinCharPerChat
                        ) {
                          setIsMessageValid(false);

                          setInvalidMessageCause(
                            `Your message is too short (less than ${selectedChat.MinCharPerChat} characters).`
                          );

                          return;
                        }

                        selectedChat.ChatSource === "WABA"
                          ? handleSendMessageWA(chatMessage)
                          : selectedChat.ChatSource === "FBCHAT"
                            ? handleSendMessageFB(chatMessage)
                            : selectedChat.ChatSource === "LIVECHAT"
                              ? handleSendMessageLiveChat(chatMessage)
                              : handleSendMessageIG(chatMessage);
                      }
                    }}
                  />

                  <IconButton
                    disabled={isSending || !isMessageValid}
                    type="submit"
                    onClick={(event) => {
                      event.preventDefault();

                      if (hasBannedWord(chatMessage)) {
                        setIsMessageValid(false);

                        setInvalidMessageCause(
                          "Your message contained banned words."
                        );

                        return;
                      }

                      if (
                        selectedChat.MinCharPerChat &&
                        chatMessage.length < selectedChat.MinCharPerChat
                      ) {
                        setIsMessageValid(false);

                        setInvalidMessageCause(
                          `Your message is too short (less than ${selectedChat.MinCharPerChat} characters).`
                        );

                        return;
                      }

                      selectedChat.ChatSource === "WABA"
                        ? handleSendMessageWA(chatMessage)
                        : selectedChat.ChatSource === "FBCHAT"
                          ? handleSendMessageFB(chatMessage)
                          : selectedChat.ChatSource === "LIVECHAT"
                            ? handleSendMessageLiveChat(chatMessage)
                            : handleSendMessageIG(chatMessage);
                    }}
                  >
                    {isSending ? (
                      <Icon
                        height="24"
                        icon="eos-icons:loading"
                        color="#727272"
                      />
                    ) : (
                      <SendOutlinedIcon />
                    )}
                  </IconButton>

                  {invalidMessageCause && (
                    <p className="invalid-message-cause">
                      {invalidMessageCause}
                    </p>
                  )}
                </form>
              </div>
            </>
          )}
        </div>
      )}

      {openModalSave ? (
        /* <SaveResultModal
          confirmEndChat={confirmEndChat}
          onClose={() => setOpenModalSave(false)}
        /> */

        <ResultCallModal
          isFromChat
          isOpen={openModalSave}
          ISPlan={ISPlan}
          setIsResultCallModalShown={setOpenModalSave}
          confirmEndChat={confirmEndChat}
          chatSource={selectedChat.ChatSource}
          handleEndChatWABA={handleEndChatWABA}
        />
      ) : (
        ""
      )}

      {openModalTicket ? (
        <EditTicketModal
          confirmEndChat={confirmEndChat}
          onClose={() => setOpenModalTicket(false)}
        />
      ) : (
        ""
      )}

      {openModalAssignAgent ? (
        <AssignAgentModal
          agentToAssign={agentToAssign}
          currentAssignedAgent={selectedChat.AgentID}
          onClose={() => {
            setOpenModalAssignAgent(false);
            setAgentToAssign(null);
          }}
          setAgentToAssign={setAgentToAssign}
          setIsAssignAgentWarningShown={setIsAssignAgentWarningShown}
        />
      ) : (
        ""
      )}

      <WarningDialog
        confirmAction={assignAgent}
        contents={
          <>
            <p>
              You are about to assign this chat to{" "}
              <span>{agentToAssign?.AgentName}</span>.
            </p>

            <p>Are you sure?</p>
          </>
        }
        isOpen={isAssignAgentWarningShown}
        isProcessing={isAssigning}
        setIsOpen={setIsAssignAgentWarningShown}
      />

      {openModalCampaignDetail ? (
        <HistoryDetailModal onClose={() => setOpenModalCampaignDetail(false)} />
      ) : (
        ""
      )}

      {openModal_HistoryChat ? (
        <ModalHistory
          ChatListID={selectedChat.ChatListID}
          // Check used because FB, IG, and WABA use WAID
          FBID={selectedChat.ChatSource === "FBCHAT" ? selectedChat.WAID : null}
          IGID={selectedChat.ChatSource === "IG" ? selectedChat.WAID : null}
          WAID={selectedChat.ChatSource === "WABA" ? selectedChat.WAID : null}
          isAllHistoryShown={selectedChat.ChatSource === "WABA"}
          onClose={() => setOpenModal_HistoryChat(false)}
        />
      ) : (
        ""
      )}

      <ProfileInfo
        // contactID={selectedChat.OutboundContactID}
        // contactName={selectedChat.ProfileName}
        contactID={selectedChat.ContactID}
        contactName={selectedChat.ContactName}
        open={isProfileInfoOpen}
        onClose={() => setIsProfileInfoOpen(false)}
        selectContact={selectContact}
      />

      <Dialog
        open={isCreateTicketDialogShown}
        className="dialog"
        fullWidth
        maxWidth="lg"
        scroll="paper"
        onClose={() => setIsCreateTicketDialogShown(false)}
      >
        <CreateTicket
          chatListID={selectedChat.ChatListID}
          chatSource={selectedChat.ChatSource}
          contactID={selectedChat.contactID}
          email={selectedChat.email}
          handleEndChat={handleEndChat}
          mobileNo={selectedChat.MobileNo}
          setIsCreateTicketDialogShown={setIsCreateTicketDialogShown}
        />
      </Dialog>

      {isNewWindowOpen && (
        <NewWindow
          copyStyles
          features={{
            height: 550,
            width: width >= 1440 ? 1440 : 900,
          }}
          onUnload={() => setIsNewWindowOpen(false)}
        >
          <QAForm
            caseID={selectedChat.ChatListID}
            channelID={chatInfo?.ChannelID}
            filledComment={chatInfo?.CommentQA}
            filledTotalScore={chatInfo?.TotalScoreQA}
            scoreItemID={chatInfo?.ScoreItemID}
            setIsNewWindowOpen={setIsNewWindowOpen}
          />
        </NewWindow>
      )}
    </div>
  );
}
